import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchRewardsPolicyCount } from "../../store/rewards/rewardsSlice";
import { REWARD_GROUPS } from "./rewardData";

export default function useRewardsProgramme(token) {
  const dispatch = useDispatch();
  const rewardsProgress = useSelector((state) => state.rewards);

  useEffect(() => {
    dispatch(fetchRewardsPolicyCount({ token }));
  }, [dispatch, token]);

  return {
    groups: REWARD_GROUPS,
    policyCount: rewardsProgress.policyCount,
    isLoading: rewardsProgress.status === "idle" || rewardsProgress.status === "loading",
    error: rewardsProgress.error,
  };
}
